module.exports = __webpack_public_path__ + "img/pctan.95ae9676.png";